import React, { useEffect, useState } from 'react';
import Cart from '../Cart/Cart';
import Products from '../Products/Products';

const Shop = () => {
    const [products, setProducts] = useState([]);
    useEffect( () => {
        fetch('./products.JSON')
        .then(response => response.json())
        .then(data => setProducts(data))
    }, []);

    const [items, setItems] = useState([]);
    const addItemBtn = product => {
        const allProducts = [...items, product];
        setItems(allProducts);
    }

    return (
        <div className="container text-start py-3">
            <h2 className="border-bottom border-info d-inline pb-2">Here is the products !</h2>
            <div className="row">
                <div className="col-md-7">
                    <div className="row mt-5">
                    {
                        products.map(product => <Products 
                            key = {product.id}
                            products={product}
                            addItemBtn = {addItemBtn}
                            >
                            </Products>)
                    }
                    </div>
                </div>
                <div className="col-md-5 mt-3">
                    <Cart products={items}></Cart>
                </div>
            </div>
        </div>
    );
};

export default Shop;